<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">智能体管理</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.coze_name" placeholder="请输入名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增智能体
        </el-button>
      </div>

      <!-- 智能体列表 -->
      <el-table :data="cozeList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="coze_name" label="名称" width="180" />
        <!-- 新增类型列 -->
        <el-table-column label="类型" width="100">
          <template #default="scope">
            <el-tag :type="getTypeByUrl(scope.row.coze_url) === 'workflow' ? 'success' : 'primary'">
              {{ getTypeByUrl(scope.row.coze_url) === 'workflow' ? '工作流' : '智能体' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="coze_botid" label="ID" width="180" />
        <el-table-column prop="coze_url" label="接口地址" min-width="200" show-overflow-tooltip />
        <el-table-column prop="notes" label="备注" width="150" />
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <el-table-column label="操作" width="280" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
              <el-icon>
                <Edit />
              </el-icon>
              编辑
            </el-button>

            <el-button type="success" size="small" @click="testConnectivity(scope.row)">
              <el-icon>
                <Connection />
              </el-icon>测试
            </el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchCozeList" @current-change="fetchCozeList" />
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">

      <div class="api-tip-box">
        <el-alert title="还没有coze接口密钥？" type="info" :closable="false" show-icon center>
          <template #default>
            <a href="https://www.coze.cn/home" target="_blank" class="api-link">
              立即申请coze接口
            </a>
          </template>
        </el-alert>
      </div>
      <el-form ref="cozeForm" :model="cozeForm" label-width="120px" :rules="formRules">
        <!-- 类型选择下拉框 -->
        <el-form-item label="类型选择" prop="type">
          <el-select v-model="cozeForm.type" placeholder="请选择类型" size="large" style="width: 100%"
            @change="handleTypeChange">
            <el-option label="智能体" value="agent" />
            <el-option label="工作流" value="workflow" />
          </el-select>
        </el-form-item>

        <el-form-item :label="cozeForm.type === 'agent' ? '智能体名称' : '工作流名称'" prop="coze_name">
          <el-input v-model="cozeForm.coze_name" :placeholder="cozeForm.type === 'agent' ? '请输入智能体名称' : '请输入工作流名称'"
            size="large" />
        </el-form-item>

        <el-form-item :label="cozeForm.type === 'agent' ? '智能体密钥' : '工作流密钥'" prop="coze_access_token">
          <el-input v-model="cozeForm.coze_access_token"
            :placeholder="cozeForm.type === 'agent' ? '请输入智能体密钥' : '请输入工作流密钥'" size="large" show-password />
        </el-form-item>

        <el-form-item :label="cozeForm.type === 'agent' ? '智能体ID' : '工作流ID'" prop="coze_botid">
          <el-input v-model="cozeForm.coze_botid" :placeholder="cozeForm.type === 'agent' ? '请输入智能体ID' : '请输入工作流ID'"
            size="large" />
        </el-form-item>

        <el-form-item label="接口地址" prop="coze_url">
          <el-input v-model="cozeForm.coze_url" placeholder="请输入Coze接口地址" size="large" @input="handleUrlInput" />
          <div class="form-tip" v-if="showUrlTip">
            {{ urlTip }}
          </div>
        </el-form-item>


        <!-- 新增：测试连通性按钮 -->
        <el-form-item label="测试连通性">
          <el-button type="primary" size="large" @click="testConnection" :loading="testingConnection"
            :disabled="!cozeForm.coze_url || !cozeForm.coze_access_token || !cozeForm.coze_botid">
            <el-icon>
              <Connection />
            </el-icon>
            测试连通性
          </el-button>
          <span class="test-result" :class="{ 'success': testResult === 'success', 'error': testResult === 'error' }">
            {{ testResult === 'success' ? '✓ 测试通过' : testResult === 'error' ? '✗ 测试失败' : '' }}
          </span>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="cozeForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCozeForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Edit, Delete, Connection
} from '@element-plus/icons-vue'

export default {
  name: 'SystemClever',
  components: { Search, Plus, Edit, Delete, Connection },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      testingConnection: false,
      testResult: '', // 测试结果状态 'success' | 'error' | ''
      dialogTitle: '新增智能体',
      isEditMode: false,
      searchForm: {
        coze_name: ''
      },
      cozeForm: {
        id: null,
        type: 'agent', // 新增类型字段，默认值设为智能体
        coze_name: '',
        coze_url: 'https://api.coze.cn/v3/chat', // 智能体默认地址
        coze_access_token: '',
        coze_botid: '',
        notes: ''
      },

      // 用户是否手动修改了接口地址
      isUrlModified: false,
      // 接口类型对应的默认地址
      DEFAULT_URLS: {
        agent: 'https://api.coze.cn/v3/chat',
        workflow: 'https://api.coze.cn/v1/workflow/run'
      },
      formRules: {
        coze_name: [
          { required: true, message: '请输入智能体名称', trigger: 'blur' }
        ],
        coze_url: [
          { required: true, message: '请输入接口地址', trigger: 'blur' }
        ],
        coze_access_token: [
          { required: true, message: '请输入智能体密钥', trigger: 'blur' }
        ],
        coze_botid: [
          { required: true, message: '请输入智能体ID', trigger: 'blur' }
        ]
      },
      cozeList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    },
    // 当前类型的地址提示
    urlTip() {
      return this.cozeForm.type === 'agent'
        ? '智能体默认接口地址'
        : '工作流默认接口地址';
    },

    // 是否显示地址提示（当使用默认地址时显示）
    showUrlTip() {
      return !this.isUrlModified &&
        this.cozeForm.coze_url === this.DEFAULT_URLS[this.cozeForm.type];
    }
  },
  mounted() {
    this.fetchCozeList();
  },
  methods: {
    // 测试连通性方法
    async testConnectivity(row) {
      try {
        this.loading = true;

        // 根据类型调用不同的测试方法
        if (this.getTypeByUrl(row.coze_url) === 'workflow') {
          this.$message.warning('工作流暂时无法测试连通性！');
      return;
        } else {
          await this.testAgentConnection(row);
        }

      } catch (error) {
        console.error('测试连接失败:', error);
        this.$message.error('测试连接失败: ' + (error.response?.data?.msg || error.message));
      } finally {
        this.loading = false;
      }
    },

    async testConnection() {
      try {
        this.testingConnection = true;
        this.testResult = '';

        // 根据类型调用不同的测试方法
        if (this.cozeForm.type === 'workflow') {
          
          this.$message.warning('工作流暂时无法测试连通性！');
      return;
        } else {
          await this.testAgentConnection(this.cozeForm);
        }

        this.testResult = 'success';
        this.$message.success('连接测试成功！');
      } catch (error) {
        console.error('测试连接失败:', error);
        this.testResult = 'error';
        this.$message.error('测试连接失败: ' + (error.response?.data?.msg || error.message));
      } finally {
        this.testingConnection = false;
      }
    },

    // 测试智能体连接
    async testAgentConnection(row) {
      const testData = {
        bot_id: row.coze_botid,
        user_id: "test_user_" + Date.now(), // 使用唯一用户ID
        stream: false,
        auto_save_history: true,
        additional_messages: [{
          role: "user",
          content: "你好，这是一条测试消息",
          content_type: "text"
        }]
      };

      const response = await axios.post(
        row.coze_url,
        testData,
        {
          headers: {
            'Authorization': `Bearer ${row.coze_access_token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.code === 0) {
        this.$message.success('智能体连接测试成功！');
      } else {
        throw new Error(response.data.msg || '未知错误');
      }
    },


    // 通过URL获取类型
    getTypeByUrl(url) {
      if (!url) return 'agent';
      return url.includes('workflow') ? 'workflow' : 'agent';
    },

    // 获取智能体列表
    async fetchCozeList() {
      this.loading = true;
      try {
        const params = {
          action: 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        // 如果有搜索条件，加入搜索参数
        if (this.searchForm.coze_name) {
          params.coze_name = this.searchForm.coze_name;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/CozeSettingsController.php`,
          params
        );

        if (data.data) {
          this.cozeList = data.data;
          this.pagination.total = data.pagination.total;
        }
      } catch (error) {
        this.$message.error('获取智能体列表失败');
        console.error('获取智能体列表错误:', error);
      } finally {
        this.loading = false;
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchCozeList();
    },

    // 处理类型切换
    handleTypeChange() {
      // 如果用户没有修改过地址，自动更新为对应类型的默认地址
      if (!this.isUrlModified) {
        this.cozeForm.coze_url = this.DEFAULT_URLS[this.cozeForm.type];
      }

      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.cozeForm) {
          this.$refs.cozeForm.clearValidate();
        }
      });
    },

    // 处理地址输入
    handleUrlInput() {
      // 标记用户已手动修改地址
      this.isUrlModified = true;
    },

    // 打开新增对话框
    openAddDialog() {
      this.dialogTitle = '新增智能体';
      this.isEditMode = false;
      this.cozeForm = {
        id: null,
        type: 'agent', // 默认类型为智能体
        coze_name: '',
        coze_url: this.DEFAULT_URLS.agent, // 默认智能体地址
        coze_access_token: '',
        coze_botid: '',
        notes: ''
      };
      this.isUrlModified = false;

      this.dialogVisible = true;
    },

    openEditDialog(row) {
      // 根据URL确定类型
      const type = this.getTypeByUrl(row.coze_url);
      this.dialogTitle = type === 'agent' ? '编辑智能体' : '编辑工作流';
      this.isEditMode = true; // 明确设置为编辑模式

      this.cozeForm = {
        id: row.id,
        type: type, // 设置对话框中的类型
        coze_name: row.coze_name,
        coze_url: row.coze_url, // 使用原有的URL
        coze_access_token: row.coze_access_token,
        coze_botid: row.coze_botid,
        notes: row.notes
      };

      // 检测地址是否被用户修改过
      const defaultUrl = this.DEFAULT_URLS[type];
      this.isUrlModified = row.coze_url !== defaultUrl;

      this.dialogVisible = true;
    },
    // 提交表单（新增/编辑）
    submitCozeForm() {
      this.$refs.cozeForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const payload = {
              ...this.cozeForm,
              store_id: this.userInfo.id
            };

            // 不发送type字段到后端，我们只需保存URL
            delete payload.type;

            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/CozeSettingsController.php`,
              {
                action,
                ...payload
              }
            );

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchCozeList();
            }
          } catch (error) {
            this.$message.error('操作失败');
            console.error('表单提交错误:', error);
          }
        }
      });
    },

    // 删除智能体
    async handleDelete(id) {
      this.$confirm('确定要删除该智能体吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/CozeSettingsController.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchCozeList();
          }
        } catch (error) {
          this.$message.error('删除失败');
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles/page-common.scss' as *;

/* 对话框样式优化 */
:deep(.el-dialog) {
  border-radius: 12px;

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #ebeef5;
    margin-right: 0;

    .el-dialog__title {
      font-weight: 600;
      color: #1f2937;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
  }
}


/* 新增的coze提示样式 */
.api-tip-box {
  margin-bottom: 20px;

  .api-link {
    display: inline-block;
    margin-left: 8px;
    font-weight: 600;
    color: #1890ff;
    text-decoration: none;
    transition: all 0.3s;
    padding: 4px 8px;
    border-radius: 4px;

    &:hover {
      color: #096dd9;
      background-color: rgba(24, 144, 255, 0.1);
      text-decoration: underline;
    }

    &::after {
      content: "↗";
      margin-left: 5px;
      font-size: 0.9em;
    }
  }
}

/* 新增表单项提示样式 */
.form-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #67c23a;
  padding: 4px 8px;
  background: #f0f9eb;
  border-radius: 4px;
  display: inline-block;
}

/* 新增测试结果样式 */
.test-result {
  margin-left: 15px;
  font-size: 14px;

  &.success {
    color: #67c23a;
  }

  &.error {
    color: #f56c6c;
  }
}
</style>